import { ajax } from "jquery";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { QuoteInvoiceFormInterface } from "../abstracts/mixins/QuoteInvoiceFormInterface";


export class ServiceInvoice extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'customer_payments';
        this.urlRoot = '/jobs-flow/service-invoice';
        this.sectionRootUrl = '/jobs-flow';
        this.id = id;

        Object.assign(ServiceInvoice.prototype, FormActions);
        Object.assign(ServiceInvoice.prototype, EntityModalForm);
        Object.assign(ServiceInvoice.prototype, HasStatus);
        Object.assign(ServiceInvoice.prototype, QuoteInvoiceFormInterface);
    }

    static statusList = {
        CREATED: 0,
        PENDING: 1,
        SUCCESS: 2,
        FAILED: 3,
        CANCELED: 4,
        PARTIALLY_REFUNDED: 5,
        REFUNDED: 6,
        DECLINED: 7,
        DISPUTED: 8,
    }
}
